'use strict';


define('forum/infinitescroll-newhome', [], function () {
	const scroll = {};
	let callback;
	let previousScrollTop = 0;
	let container;
	let scrollTimeout = 0;

	scroll.init = function (cb) {
		container = $('body');
		callback = cb;
		previousScrollTop = $(window).scrollTop();
		$(window).off('scroll', startScrollTimeout).on('scroll', startScrollTimeout);
	};

	function startScrollTimeout() {
		if (scrollTimeout) {
			clearTimeout(scrollTimeout);
		}
		scrollTimeout = setTimeout(function () {
			scrollTimeout = 0;
			onScroll();
		}, 60);
	}

	function onScroll() {
		const bsEnv = utils.findBootstrapEnvironment();
		const mobileComposerOpen = (bsEnv === 'xs' || bsEnv === 'sm') && $('html').hasClass('composing');
		if (mobileComposerOpen) {
			return;
		}
		const currentScrollTop = $(window).scrollTop();
		const wh = $(window).height();
		const fromTop = currentScrollTop;
		const fromBottom = container.height() - wh - currentScrollTop;

		const distance = 0.20 * wh;
		const direction = currentScrollTop > previousScrollTop ? 1 : -1;

		if (fromTop < distance && currentScrollTop < previousScrollTop) {
			callback(direction);
		} else if (fromBottom < distance && currentScrollTop > previousScrollTop) {
			callback(direction);
		}

		previousScrollTop = currentScrollTop;
	}

	return scroll;
});
